import { data } from '../../svg/TextField/data';
import { makeIcon } from '../makeIcon';

export const TextField = makeIcon(data, 'text_field', 'TextField');

export default TextField;
